export const Footer = () => {
  return (
    <footer className="bg-[#0A0907] border-t border-[rgba(242,236,224,0.06)]">
      <div className="container px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto py-10">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-sm">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 rounded-md bg-[hsl(var(--lime))] flex items-center justify-center">
              <span className="text-[#050505] text-lg font-black leading-none">✱</span>
            </div>
            <div>
              <div className="font-serif-tc text-[15px] font-bold text-[hsl(var(--foreground))]">
                AI × 短片變現分享會
              </div>
              <div className="text-[11px] text-[hsl(var(--muted-foreground))]">
                講師｜Jacky Lei｜個人 IP 孵化流量操盤手
              </div>
            </div>
          </div>
          <div className="text-[11px] text-[hsl(var(--muted-foreground))]">
            © {new Date().getFullYear()} ZUOIP · ALL RIGHTS RESERVED
          </div>
        </div>
      </div>
    </footer>
  );
};
